import React from "react";

//配置项
const componentName = "audienceGroup";

function columns() {
  return [
    {
      name: "id",
    },
    {
      title: "名称",
      name: "name",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "说明",
      name: "intro",
      tableItem: {},
    },
    {
      title: "受众组",
      name: "groupScope",
      tableItem: {
        render: (text, record) => <a onClick={() => this.handleLook(text)}>查看受众组</a>
      },
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort: ["add"],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/audience/group/add",
                },
              },
            },
          ],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ["look", "update"],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/audience/group/preview",
              },
            },
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/audience/group/upd",
              },
            },
          },
        ],
        commonOperate: {
          add: true,
          update: true,
        },
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { },
    },
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
